<template>
	<div class="innovate-icon">
		<img v-for="item in imgList" :class="'icon'+item"  :data-src="g+'/'+item+'.png'" />
	</div>
</template>

<script>
	export default{
		name: "",
		components: {},
		data(){
			 let g=process.env.VUE_APP_BASE_URL+'sustainability'
			return{
				g:g,
				imgList:['97','98','99','100','101','102','103','104-1','105','106','107','108']
			}
		}
	}
</script>

<style lang="scss" scoped >
	.innovate-icon{
		position: relative;
		width: 63px;
		height: 84px;
		display: inline-block;
		transform: translate(0px, 0px) rotate(270.000deg) skew(0.000deg);
		.icon97{
			   height: 43.24px;
			       left: 0px;
			       position: absolute;
			       top: 0px;
			       transform: translate(-0.001px, 41.020px) rotate(0.000deg) skew(0.000deg) scale(1.000, 1.000);
			       transform-origin: 0% 0%;
			       width: 35.48px;
		}
		.icon98{    height: 40.00px;
    left: 0px;
    position: absolute;
    top: 0px;
    transform: translate(25.189px, 0.000px) rotate(0.000deg) skew(0.000deg) scale(1.000, 1.000);
    transform-origin: 0% 0%;
    width: 38.18px;}
	.icon99{
		    height: 13.12px;
		    left: 0px;
		    position: absolute;
		    top: 0px;
		    transform: translate(22.793px, 33.672px) rotate(0.000deg) skew(0.000deg) scale(1.000, 1.000);
		    transform-origin: 0% 0%;
		    width: 13.71px;
	}
	.icon100{
		    height: 4.09px;
		    left: 0px;
		    position: absolute;
		    top: 0px;
		    transform: translate(22.786px, 45.696px) rotate(0.000deg) skew(0.000deg) scale(1.000, 1.000);
		    transform-origin: 0% 0%;
		    width: 3.60px;
	}
	.icon101{
		height: 2.36px;
		    left: 0px;
		    position: absolute;
		    top: 0px;
		    transform: translate(37.918px, 37.583px) rotate(0.000deg) skew(0.000deg) scale(1.000, 1.000);
		    transform-origin: 0% 0%;
		    width: 4.20px;
	}
	.icon102{
		    height: 2.58px;
		    left: 0px;
		    position: absolute;
		    top: 0px;
		    transform: translate(18.295px, 40.772px) rotate(0.000deg) skew(0.000deg) scale(1.000, 1.000);
		    transform-origin: 0% 0%;
		    width: 4.18px;
	}
	.icon103{
		height: 3.33px;
		    left: 0px;
		    position: absolute;
		    top: 0px;
		    transform: translate(35.828px, 32.098px) rotate(0.000deg) skew(0.000deg) scale(1.000, 1.000);
		    transform-origin: 0% 0%;
		    width: 3.93px;
	}
	.icon104-1{
		    height: 2.72px;
		    left: 0px;
		    position: absolute;
		    top: 0px;
		    transform: translate(18.778px, 34.843px) rotate(0.000deg) skew(0.000deg) scale(1.000, 1.000);
		    transform-origin: 0% 0%;
		    width: 3.89px
	}
	.icon105{    height: 3.92px;
    left: 0px;
    position: absolute;
    top: 0px;
    transform: translate(24.140px, 29.178px) rotate(0.000deg) skew(0.000deg) scale(1.000, 1.000);
    transform-origin: 0% 0%;
    width: 2.69px;}
	.icon106{    height: 4.48px;
    left: 0px;
    position: absolute;
    top: 0px;
    transform: translate(30.251px, 27.688px) rotate(0.000deg) skew(0.000deg) scale(1.000, 1.000);
    transform-origin: 0% 0%;
    width: 2.40px;}
	.icon107{height: 3.09px;
    left: 0px;
    position: absolute;
    top: 0px;
    transform: translate(36.270px, 43.539px) rotate(0.000deg) skew(0.000deg) scale(1.000, 1.000);
    transform-origin: 0% 0%;
    width: 2.80px;}
	.icon108{    height: 4.03px;
    left: 0px;
    position: absolute;
    top: 0px;
    transform: translate(31.127px, 47.999px) rotate(0.000deg) skew(0.000deg) scale(1.000, 1.000);
    transform-origin: 0% 0%;
    width: 2.14px;}
	}
	
	
</style>